export default __webpack_public_path__ + "static/media/base-course-item-preview1.28772062.jpg";